<div class="email-confirmation-banner">
  <div class="banner-content">
    <mat-icon svgIcon="mat_outline:email"></mat-icon>
    <div class="text">
      <div class="title">{{ title | transloco}}</div>
      <div class="subtitle">{{ subtitle |transloco}}</div>
    </div>
  </div>
  <div class="actions">
    <button type="button" class="confirm-button" (click)="confirm.emit()">{{ 'confirm_email.confirm' | transloco }}</button>
    <button type="button" class="close-button" (click)="close.emit()">
      <mat-icon svgIcon="mat_outline:close"></mat-icon>
    </button>
  </div>
</div>
